import { render, staticRenderFns } from "./painel-de-atendimento.vue?vue&type=template&id=4d985568"
import script from "./painel-de-atendimento.vue?vue&type=script&lang=js"
export * from "./painel-de-atendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports